<template>
  <tool-advance-filter-content
    :contentInfo="contentInfo"
    :chartProperties="chartProperties"
    :chartData="chartGraphData"
    :selectedComponent="selectedChartComponent"
    :addButtonText="addButtonText"
    :updateButtonText="updateButtonText"
    :headers="headers"
    :rows="rows"
    :infoText="infoText"
    :infoError="infoError"
    :baselineTitle="baselineRow.title"
    :headerbaseline="baselineHeader"
    :rowsbaseline="baselineRow.rows"
    @editableRowButtonClick="genericMethodClick"
    :singleHeading="singleHeading"
    :singleHeadingOptions="singleHeadingOptions"
    :singleHeadingButtonText="singleHeadingButtonText"
    :gridSplitId="gridSplitId"
    :isShowHint="isShowHint"
    :emptyChartMessage="emptyChartMessage"
    @addRow="addRow"
    @GridSelectionChange="AddNewTypeRow"
    @setFocusOnRowElement="setFocusOnRowElement"
    :focusElementName="focusElementName"
    :gridButtonTemplate="gridButtonTemplate"
    :rowTemplateButton="rowTemplateButton"
    @rowTemplateButtonClick="genericMethodClick"
    @OuterRowButtonClick="genericMethodClick"
    :rowOuterButton="rowOuterButton"
    @onChange="OnOptionChange"
    :emptyGridData="emptyGridData"
    @removeRow="removeRow"
    @onChangeChartTab="onChangeChartTab"
    :tableViewSettings="tableSetting"
    :showTableView="showTable"
    :buttonDataTypeConfig="buttonDataTypeConfig"
    :buttonViewTypeConfig="buttonViewTypeConfig"
    @onSelectDataTypeFilter="onSelectDataTypeFilter"
    @onSelectViewTypeFilter="onSelectViewTypeFilter"
  ></tool-advance-filter-content>
</template>
<script>
import { ToolAdvanceFilterContent } from "../../component/tool";
import { LoanAdvanceFilterContent } from "../../mixin";
import { ICELoanIntegration } from "../../mixin";
import {
  AdvanceFilter,
  DATETYPE,
  RepeymentTypeSelectOptions,
  RepaymentTypeOptionValue,
} from "../../helpers/constant";
import { mapGetters } from "vuex";
import { GET_LIABLITY_INFORMATION } from "../../helpers/vuex-constants";

import _ from "lodash";
import { GET_SELECTED_LIABLITY_INFORMATION } from "../../helpers/vuex-constants";
export default {
  props: {
    tableViewSettings: {
      type: Object,
    },
    showTableView: {
      type: Boolean,
      default: false,
    },
    baselineData: {
      type: Object,
    },
  },
  components: { ToolAdvanceFilterContent },
  mixins: [LoanAdvanceFilterContent, ICELoanIntegration],
  computed: {
    gridButtonTemplate() {
      return this.EnableDisableButtons();
    },
    legendItems() {
      return ["Base Repayment", "Repayment Adjustments"];
    },
    baselineFilterObject() {
      return Object.assign({}, this.baselineData);
    },
    ...mapGetters("loan", {
      selectedLoanData: GET_SELECTED_LIABLITY_INFORMATION,
      getLiablityInformation: GET_LIABLITY_INFORMATION,
    }),
  },
  mounted() {
    this.fillLoanModel(AdvanceFilter.Repayment);
    this.validations(
      this.baselineFilterObject.advancedetails,
      AdvanceFilter.Repayment
    );
  },
  async created() {
    this.setChartViewTypeDropDown();
    this.setChartDataTypeDropDown();
  },
  data() {
    return {
      buttonDataTypeConfig: [],
      buttonViewTypeConfig: [],
      emptyGridData: {
        title:
          "Click to add Lump Sum Repayment or Changes to Regular Repayments",
        message: "",
        imagepath: "../../assets/icons/dollar.svg",
        buttonVisible: true,
        list: [],
      },
      rowOuterButton: [
        // {
        //   icon: "trash",
        //   size: "large",
        //   variation: "icon-only",
        //   text: "Add New",
        //   callBackMethod: "DeleteSubtype",
        //   isdisabled: false,
        //   key: "deletesubtype",
        // },
      ],
      focusElementName: "",
      rowTemplateButton: [
        {
          icon: "plus",
          size: "medium",
          variation: "flat",
          text: "Add New",
          callBackMethod: "AddNewTypeRow",
          isdisabled: false,
          key: "AddNewTypeRow",
        },
      ],
      gridButtonTemplatedata: [
        {
          icon: "eye",
          size: "medium",
          variation: "primary",
          text: "Preview Graph",
          callBackMethod: "UpdateGraph",
          isdisabled: false,
          key: "UpdateGraph",
        },
        // {
        //   icon: "plus",
        //   size: "medium",
        //   variation: "secondary",
        //   isdisabled: false,
        //   text: "Add New",
        //   callBackMethod: "addNewRow",
        //   key: "addRow",
        // },
        {
          size: "medium",
          variation: "secondary",
          isdisabled: true,
          text: "Reset",
          callBackMethod: "reset",
          key: "reset",
        },
      ],
      timeSeriesChartData: this.getTimeSeriesCoordinate(
        this.baselineData.advancedetails,
        AdvanceFilter.Repayment,
        this.baselineData.projectionYear
      ),
      emptyChartMessage: {
        message: "Add Repayment details to create a chart.",
        btnTxt: "",
      },
      baselineRow: {
        title: "Baseline Repayment",
        rows: [
          {
            repaymentType: { value: this.baselineData.repaymentType },
            repaymentAmount: { value: this.baselineData.repaymentAmount },
          },
        ],
      },
      baselineHeader: this.getEditBaselineHeader(),

      contentInfo: {
        heading: "Repayment",
        subHeading:
          "You can enter in repayment details at different time periods.",
        infoAlert: {
          title: "Important note",
          variation: "informational",
          text: "Setting loan repayment amount to 0 will auto calculate the repayment based on the amount owing, interest rate and remaining term.",
        },
      },
      updateButtonText: "Update Graph",
      addButtonText: "Add new",
      isShowHint: true,
      infoText: ["Hit 'Tab' to move to the next cell and add a new row"],
      infoError: false,
      singleHeading: "Repayments Adjustment",
      singleHeadingOptions: [
        {
          key: 1,
          value: "Regular",
          fields: [
            "RepaymentType",
            "Amount",
            "Frequency",

            "StartDate",

            "EndDate",
            "Description",
          ],
          overlapvalidations: true,
        },
        {
          key: 2,
          value: "Lump Sum",
          fields: ["Amount", "StartDate", "Description"],
          overlapvalidations: false,
          showDateLabel: true,
        },
        // {
        //   key: 3,
        //   value: "Lump Sum",
        //   fields: [
        //     "Amount",
        //     "StartDateType",
        //     "StartDate",
        //     "EffectiveAsON",
        //     "Description",
        //   ],
        //   overlapvalidations: false,
        // },
        // {
        //   key: 4,
        //   value: "Pause Repayments",
        //   fields: [
        //     "StartDateType",
        //     "StartDate",
        //     "EndDateType",
        //     "EndDate",
        //     "Description",
        //   ],
        //   overlapvalidations: true,
        // },
        // {
        //   key: 5,
        //   value: "Auto Repayments",
        //   fields: [
        //     "StartDateType",
        //     "StartDate",
        //     "EndDateType",
        //     "EndDate",
        //     "Description",
        //   ],
        //   overlapvalidations: true,
        // },
      ],
      singleHeadingButtonText: "",
      gridSplitId: "subTypeId",
      headers: [
        {
          type: "Dropdown",
          label: "Repayment Type",
          cols: 2,
          key: "RepaymentType",
          options: RepeymentTypeSelectOptions,
          defaultValue: "",
          validation: true,
          style: {
            width: "150px",
            overflow: "visible",
          },
        },

        {
          type: "FormatInput",
          label: "Amount",
          cols: 1,
          key: "Amount",
          isAllowOnlyNumber: true,
          appendText: "",
          currencyFormat: "$,",
          max: 999999999,
          length: 9,
          validation: true,
          style: {
            width: "150px",
            overflow: "visible",
          },
        },
        // {
        //   type: "Dropdown",
        //   label: "Index",
        //   cols: 1,
        //   key: "Index",
        //   options: this.indexOptions(),
        //   defaultValue: "AWOTE",
        //   validation: true,
        // },
        {
          type: "Dropdown",
          label: "Frequency",
          cols: 2,
          key: "Frequency",
          options: this.frequencyOption(),
          defaultValue: "Weekly",
          validation: true,
          style: {
            width: "150px",
            overflow: "visible",
          },
        },

        {
          type: "MonthPickerSelect",
          displayTop: true,
          showLeft: false,
          typing: true,
          label: "Start",
          text: "Date",
          cols: 1,
          key: "StartDate",
          listdata: this.startOptionsNew(),
          sort: "years",
          minYear: 2022,
          yearTerm: 50,
          style: {
            width: "160px",
            overflow: "visible",
          },
          validation: true,
        },

        {
          type: "MonthPickerSelect",
          displayTop: true,
          showLeft: true,
          typing: true,
          label: "End",
          cols: 1,
          key: "EndDate",
          listdata: this.startOptionsNew(),
          sort: "years",
          minYear: 2022,
          yearTerm: 50,
          style: {
            width: "160px",
            overflow: "visible",
          },
          validation: true,
        },
        {
          type: "Input",
          label: "Description",
          placeholder: "e.g Change in Rates",
          isAllowToAddNextRow: true,
          cols: 1,
          Option: "",
          key: "Description",
          length: 200,
        },

        {
          type: "Icon",
          label: "",
          iconText: "Validation",
          icon: "check",
          cols: 1,
          isShowDelete: true,
          isShowSuccess: false,
          class: "cf-Icon-Align",
          style: {
            width: "50px",
          },
          data: [
            {
              label: "",
              iconText: "Delete",
              icon: "trash",
              type: "icon",
              path: "",
              action: "delete",
            },
          ],
        },
      ],
      rows: this.fillGrid(),
    };
  },
  beforeMount() {
    // this.validations(
    //   this.baselineFilterObject.advancedetails,
    //   AdvanceFilter.Repayment
    // );
  },
  beforeDestroy() {
    this.fillLoanModel(AdvanceFilter.Repayment);
    this.validations(
      this.baselineFilterObject.advancedetails,
      AdvanceFilter.Repayment
    );
  },

  methods: {
    EnableDisableButtons() {
      let difference = true;
      let Loans = this.getLiablityInformation.filter(
        (sr) => sr.liabilityGuid == this.selectedLoanData.liabilityGuid
      );
      let ExistingData = Loans[0].advancedetails
        .filter((sr) => sr.typeId == AdvanceFilter.Repayment)
        .map(function (t) {
          let p = {};
          p.repaymentType = t.repaymentType;
          p.subTypeId = t.subTypeId.toString();
          p.frequency = t.frequency;
          p.startDate = t.startDate;
          p.startDateType = t.startDateType.toString();
          p.endDate = t.endDate;
          p.endDateType = t.endDateType.toString();
          p.amount = t.amount;
          p.description = t.description;
          return p;
        });
      let CurrentDataObject = [];

      for (let i = 0; i < this.rows.length; i++) {
        if (ExistingData.length > 0)
          CurrentDataObject.push({
            repaymentType: this.rows[i].RepaymentType.value,
            subTypeId: this.rows[i].subTypeId.value.toString(),
            frequency: this.rows[i].Frequency.value,
            startDate: this.rows[i].StartDate.value,
            startDateType: this.rows[i].StartDateType.value.toString(),
            endDate: this.rows[i].EndDate.value,
            endDateType: this.rows[i].EndDateType.value.toString(),
            amount: this.rows[i].Amount.value,
            description: this.rows[i].Description.value,
          });
        else {
          if (!this.validatebyrow(this.rows[i], this.rows[i].subTypeId.value)) {
            difference = false;
            break;
          }
        }
      }
      if (ExistingData.length > 0) {
        difference = _.isEqual(ExistingData, CurrentDataObject);
      }
      this.enableResetButton(difference, "UpdateGraph");
      this.enableResetButton(difference, "reset");

      return this.gridButtonTemplatedata;
    },
    getEditBaselineHeader() {
      return [
        {
          type: "Input",
          label: "Repayment Type",
          key: "repaymentType",
          options: this.baselineData.repaymentTypeOption,
          class: "",
          cols: 4,
          isdisabled: true,
          isEditiable: true,
        },
        {
          type: "Input",
          label: "Repayment Amount",
          currencyFormat: "$,",
          appendText: "",
          key: "repaymentAmount",
          isAllowOnlyNumber: true,
          class: "",
          cols: 4,
          isdisabled: true,
          isEditiable: true,
        },
        {
          type: "EditButton",
          label: "Edit",
          variation: "flat",
          key: "edit",
          icon: "pencil",
          class: "flexiblePosition",
          cols: 2,
          isdisabled: false,
          callBackMethod: "editBaseLineButton_Click",
        },
      ];
    },

    DeleteSubtype(data) {
      this.rows = this.rows.filter((x) => x.subTypeId.value != data);
    },
    // GridSelectionChange(data) {
    //   this.rows.push(this.fillData(undefined, data.key));
    // },
    fillGrid() {
      let gridRows = [];
      if (this.baselineData.advancedetails != null) {
        let data = this.baselineData.advancedetails.filter(
          (sr) => sr.typeId.value == AdvanceFilter.Repayment
        );
        if (data != null && data.length > 0) {
          gridRows = this.emptyGridRow(data);
        }
        // this.getinsertEmptyRows(gridRows);
      }

      // if (this.baselineData.advancedetails == null) {
      //   gridRows.push(this.emptyGridRow());
      // } else {
      //   let data = this.baselineData.advancedetails.filter(
      //     (sr) => sr.typeId.value == AdvanceFilter.Repayment
      //   );
      //   if (data == null || data.length == 0) {
      //     gridRows.push(this.emptyGridRow());
      //   } else {
      //     gridRows = this.emptyGridRow(data);
      //   }
      // }
      return gridRows;
    },

    async UpdateGraph() {
      this.fillLoanModel(AdvanceFilter.Repayment);
      if (
        !this.validations(
          this.baselineFilterObject.advancedetails,
          AdvanceFilter.Repayment
        )
      ) {
        await this.UpdateGraphByICEApi();
        this.timeSeriesChartData = this.getTimeSeriesCoordinate(
          this.baselineFilterObject.advancedetails,
          AdvanceFilter.Repayment,
          this.baselineData.projectionYear
        );
        this.onChangeChartTab(this.selectedChartComponent);
      }
    },

    getUserInputData(userInputRows) {
      let addtionalData = [];
      let rows = Object.assign([], userInputRows);
      rows = this.ResetMonthPickerValue(rows);
      for (let i = 0; i < rows.length; i++) {
        if (!this.validatebyrow(rows[i], rows[i].subTypeId.value)) {
          addtionalData.push({
            subTypeId: {
              value: rows[i].subTypeId.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].subTypeId.disable,
            },
            repaymentType: {
              value: rows[i].RepaymentType.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].RepaymentType.disable,
            },
            // index: {
            //   value: rows[i].Index.value,
            //   IsError: false,
            //   ErrorText: [],
            //   disable: rows[i].Index.disable,
            // },
            amount: {
              value: rows[i].Amount.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].Amount.disable,
            },
            frequency: {
              value: rows[i].Frequency.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].Frequency.disable,
            },
            startDateType: {
              value: rows[i].StartDateType.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].StartDateType.disable,
            },
            startDate: {
              value: rows[i].StartDate.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].StartDate.disable,
            },
            endDateType: {
              value: rows[i].EndDateType.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].EndDateType.disable,
            },
            endDate: {
              value: rows[i].EndDate.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].EndDate.disable,
            },
            // effectiveAsON: {
            //   value: rows[i].EffectiveAsON.value,
            //   IsError: false,
            //   ErrorText: [],
            //   disable: rows[i].EffectiveAsON.disable,
            // },
            description: {
              value: rows[i].Description.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].Description.disable,
            },
            typeId: {
              value: AdvanceFilter.Repayment,
            },
            newRow: false,
          });
        }
      }
      return addtionalData;
    },
    setFocusOnRowElement() {
      this.focusElementName = this.headers[0].key + "0";
    },

    fillData(data, subTypeId = 0) {
      let IsDataundfined = data == undefined;
      let startDateType = IsDataundfined
        ? 0
        : data.startDateType.value == 0
        ? DATETYPE.Other
        : data.startDateType.value;
      let endDateType = IsDataundfined
        ? 0
        : data.endDateType.value == 0
        ? DATETYPE.Other
        : data.endDateType.value;

      if (subTypeId == 0 && !IsDataundfined) {
        subTypeId = data.subTypeId.value;
      }

      let emptyObject = {
        // Index: {
        //   value: IsDataundfined ? 0 : data.index.value,
        //   IsError: IsDataundfined ? false : data.index.IsError,
        //   ErrorText: IsDataundfined ? [] : data.index.ErrorText,
        //   disable: IsDataundfined ? false : data.index.disable,
        // },
        RepaymentType: {
          value: IsDataundfined ? 0 : data.repaymentType.value,
          IsError: IsDataundfined ? false : data.repaymentType.IsError,
          ErrorText: IsDataundfined ? [] : data.repaymentType.ErrorText,
          disable: IsDataundfined ? false : data.repaymentType.disable,
        },
        subTypeId: {
          value: subTypeId.toString(),
          IsError: IsDataundfined ? false : data.subTypeId.IsError,
          ErrorText: IsDataundfined ? [] : data.subTypeId.ErrorText,
          disable: IsDataundfined ? false : data.subTypeId.disable,
        },
        Amount: {
          value: IsDataundfined ? 0 : data.amount.value,
          IsError: IsDataundfined ? false : data.amount.IsError,
          ErrorText: IsDataundfined ? [] : data.amount.ErrorText,
          disable: IsDataundfined
            ? false
            : !this.setDisabledtemRepayment(data.repaymentType.value).Amount,
        },
        Frequency: {
          value: IsDataundfined ? 0 : data.frequency.value,
          IsError: IsDataundfined ? false : data.frequency.IsError,
          ErrorText: IsDataundfined ? [] : data.frequency.ErrorText,
          disable: IsDataundfined
            ? false
            : !this.setDisabledtemRepayment(data.repaymentType.value).Frequency,
        },
        StartDateType: {
          value: IsDataundfined ? 0 : data.startDateType.value,
          IsError: IsDataundfined ? false : data.startDateType.IsError,
          ErrorText: IsDataundfined ? [] : data.startDateType.ErrorText,
          disable: IsDataundfined ? false : data.startDateType.disable,
        },
        StartDate: {
          value: IsDataundfined ? "" : data.startDate.value,
          IsError: IsDataundfined ? false : data.startDate.IsError,
          ErrorText: IsDataundfined ? [] : data.startDate.ErrorText,

          text: IsDataundfined
            ? ""
            : this.startOptionsNew().filter((x) => x.value == startDateType)[0]
                .text,
        },
        // EffectiveAsON: {
        //   value: IsDataundfined ? 0 : data.effectiveAsON.value,
        //   IsError: IsDataundfined ? false : data.effectiveAsON.IsError,
        //   ErrorText: IsDataundfined ? [] : data.effectiveAsON.ErrorText,
        //   disable: IsDataundfined ? false : data.effectiveAsON.disable,
        // },

        EndDateType: {
          value: IsDataundfined ? 0 : data.endDateType.value,
          IsError: IsDataundfined ? false : data.endDateType.IsError,
          ErrorText: IsDataundfined ? [] : data.endDateType.ErrorText,
          disable: IsDataundfined ? false : data.endDateType.disable,
        },
        EndDate: {
          value: IsDataundfined ? "" : data.endDate.value,
          IsError: IsDataundfined ? false : data.endDate.IsError,
          ErrorText: IsDataundfined ? [] : data.endDate.ErrorText,

          text:
            IsDataundfined || data.endDate.value == ""
              ? ""
              : this.startOptionsNew().filter((x) => x.value == endDateType)[0]
                  .text,
        },
        Description: {
          value: IsDataundfined ? "" : data.description.value,
          IsError: IsDataundfined ? false : data.description.IsError,
          ErrorText: IsDataundfined ? [] : data.description.ErrorText,
          disable: IsDataundfined ? false : data.description.disable,
        },
        newRow: IsDataundfined ? true : false,
      };
      return emptyObject;
    },

    emptyGridRow(data) {
      if (data == undefined) {
        let emptyObject = this.fillData();
        return emptyObject;
      } else {
        let gridData = [];
        for (let i = 0; i < data.length; i++) {
          gridData.push(this.fillData(data[i]));
        }
        return gridData;
      }
    },
    changeRepaymentType(data) {
      if (data.value != RepaymentTypeOptionValue.Specific_Repayment_Amount) {
        this.baselineHeader[1].isdisabled = true;
        this.baselineRow.rows[0].repaymentAmount.value = 0;
      } else {
        this.baselineHeader[1].isdisabled = false;
        this.baselineRow.rows[0].repaymentAmount.value = 0;
      }
    },

    editBaseLineButton_Click() {
      this.baselineHeader = [
        {
          type: "Dropdown",
          label: "Repayment Type",
          key: "repaymentType",
          options: this.baselineData.repaymentTypeOption,
          callBackMethod: "changeRepaymentType",
          class: "",
          cols: 4,
          isdisabled: false,
        },
        {
          type: "Input",
          label: "Repayment Amount",
          currencyFormat: "$,",
          appendText: "",
          key: "repaymentAmount",
          isAllowOnlyNumber: true,
          length: 9,
          max: 999999999,
          class: "",
          cols: 4,
          isdisabled:
            RepaymentTypeOptionValue.Specific_Repayment_Amount ==
            this.baselineFilterObject.repaymentType
              ? false
              : true,
        },
        {
          type: "Button",
          label: "Save",
          variation: "primary",
          key: "save",
          class: "shrink",
          cols: 1,
          isdisabled: false,
          callBackMethod: "saveBaseLineButton_Click",
        },
        {
          type: "Button",
          label: "Cancel",
          variation: "flat",
          key: "cancel",
          class: "shrink",
          cols: 1,
          isdisabled: false,
          callBackMethod: "cancelBaseLineButton_Click",
        },
      ];
    },
    saveBaseLineButton_Click(data) {
      if (
        this.baselineFilterObject.repaymentAmount !=
          data[0].repaymentAmount.value ||
        this.baselineFilterObject.repaymentType != data[0].repaymentType.value
      ) {
        this.enableResetButton(false, "UpdateGraph");
      }
      this.baselineFilterObject.repaymentType = data[0].repaymentType.value;
      this.baselineFilterObject.repaymentAmount = data[0].repaymentAmount.value;
      this.$emit("resetBaselineData", this.baselineFilterObject);
      this.cancelBaseLineButton_Click();
    },
    cancelBaseLineButton_Click() {
      this.baselineRow.rows[0].repaymentType.value =
        this.baselineFilterObject.repaymentType;
      this.baselineRow.rows[0].repaymentAmount.value =
        this.baselineFilterObject.repaymentAmount;
      this.baselineHeader = this.getEditBaselineHeader();
    },

    reset() {
      let Loans = this.getLiablityInformation.filter(
        (sr) => sr.liabilityGuid == this.selectedLoanData.liabilityGuid
      );
      let selectedRepData = Loans[0].advancedetails.filter(
        (sr) => sr.typeId == AdvanceFilter.Repayment
      );
      if (selectedRepData.length > 0) {
        let advanceData = [];
        for (let i = 0; i < selectedRepData.length; i++) {
          advanceData.push({
            RepaymentType: {
              value: selectedRepData[i].repaymentType,
            },
            subTypeId: {
              value: selectedRepData[i].subTypeId,
            },
            Frequency: {
              value: selectedRepData[i].frequency,
              disable: !this.setDisabledtemRepayment(selectedRepData[i].repaymentType).Frequency,
            },
            Amount: {
              value: selectedRepData[i].amount,
              disable: !this.setDisabledtemRepayment(selectedRepData[i].repaymentType).Amount,
            },
            StartDate: {
              value: selectedRepData[i].startDate,
              disable:
                selectedRepData[i].startDateType != DATETYPE.Other
                  ? true
                  : false,
            },
            StartDateType: {
              value: selectedRepData[i].startDateType,
            },
            EndDate: {
              value: selectedRepData[i].endDate,
              disable:
                selectedRepData[i].endDateType != DATETYPE.Other ? true : false,
            },
            EndDateType: {
              value: selectedRepData[i].endDateType,
            },
            Description: {
              value: selectedRepData[i].description,
            },
            typeId: {
              value: AdvanceFilter.Repayment,
            },
          });
        }
        this.rows = advanceData;
      } else {
        this.rows = [];
      }
      this.getinsertEmptyRows(this.rows);
      this.enableResetButton(false, "reset");
    },
  },
};
</script>
<style lang="scss" module></style>
